import script from "./SinglePageView.vue?vue&type=script&setup=true&lang=js"
export * from "./SinglePageView.vue?vue&type=script&setup=true&lang=js"

import "./SinglePageView.vue?vue&type=style&index=0&id=ba696504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba696504"]])

export default __exports__